import { useState, useEffect } from 'react';
import { CustomTable } from '@zeeve-platform/table-component';
import moment from 'moment';
import Urls from '../../../utils/urls';
import apiBackendInstance from '../../../utils/axios';

// const url = '';
interface AlertData {
  alertId: number,
  userId: string,
  networkId: string,
  nodeId: string,
  agentId: string,
  status: string,
  alertName: string,
  job: string,
  severity: string,
  alertType: string,
  blockchainProtocol: string,
  component: any,
  description: any,
  summary: string,
  startAt: string,
  endAt: string,
  alertTimestamp: string,
}
const AlertsWindow = () => {
  const [alertData, setAlertData] = useState([] as AlertData[]);
  const columns = [
    {
      name: 'Alert Name',
      selector: (row: any) => row.alertName,

    },
    {
      name: 'Network Id',
      selector: (row: any) => (row.networkId),
    },
    {
      name: 'Node Id',
      selector: (row: any) => (row.nodeId),
    },
    {
      name: 'Severity',
      selector: (row: any) => [(row.severity) === 'critical' ? (<button className="btn btn-danger" style={{ color: 'white' }} type="button">critical</button>) : (<button className="btn btn-warning" style={{ color: 'white' }} type="button">warning</button>)],
    },
    {
      name: 'Time',
      selector: (row: any) => moment(row.alertTimestamp).format('l'),
    },
  ];
  const getAllAlertList = () => {
    apiBackendInstance.get(Urls.getAlertList(), {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    }).then((response) => {
      if (response && response.data && response.data.data) {
        // set data
        setAlertData(response.data.data.results);
      }
    })
      .catch((err) => {
        // eslint-disable-next-line no-console
        setAlertData([]);
        console.error(err);
      });
  };
  useEffect(() => {
    //  some api calls
    getAllAlertList();
  }, []);
  return (
        <div className="card p-3">
            <div className="card-body mt-3 mb-3">
                <div className="d-flex">
                    <div className="col-xl-6 col-lg-6 col-md-5 col-sm-4">
                        <h5>Recent Alerts</h5>
                    </div>
                </div>
            </div>
            <div>
                {/* this is where we will have a table */}
                <div className="mt-2 row">
            <CustomTable
            data={alertData}
            columns={columns}
            showPagination={false}
            isLoading={false}
            isLoadingElement="Loading..."
            title=""
            />
                </div>
            </div>
        </div>
  );
};
export default AlertsWindow;
